import { render } from "./clientsEditor.vue?vue&type=template&id=9d864b2a"
import script from "./clientsEditor.vue?vue&type=script&lang=js"
export * from "./clientsEditor.vue?vue&type=script&lang=js"

import exportComponent from "/home/adachi/omega-base/omega/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__